// Get the effective visiblity of an entry.
export function getEffectiveVisibility(entry) {
    if (entry.entry_hidden !== null) return !entry.entry_hidden;

    // this should really always return true, because the API only
    // return entries that have a pricebook entry of pricebook_hidden = false
    if (entry.pricebook_restrict_visibility_override) {
        return !entry.pricebook_hidden;
    }

    return false;
}



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/override_pricebook/helpers.js